import React from 'react';
import { __ } from 'i18n/index';
import { formatLadderTime } from 'react/elements/LadderTime';

function eventText(event, username) {
	switch(event) {
		case 'asked':
			return __('%s asked for a moderator', username);
		case 'joined':
			return __('%s (moderator) joined the chat', username);
		case 'left':
			return __('%s left the chat', username);
		default:
			return null;
	}
}

// A match chat's moderator event (message kind 'moderator_event'), drawn as
// one line with its time: a player asking for a moderator in gold, a mod
// joining or leaving in mod blue. It is a system message: no sender row,
// reactions or toolbar.
export default function ModeratorEventLine({ message }) {
	const moderatorEvent = message.getModeratorEvent();
	const text = moderatorEvent && moderatorEvent.player ? eventText(moderatorEvent.event, moderatorEvent.player.username) : null;
	if(!text) {
		return null;
	}
	const time = message.time ? formatLadderTime(message.time, 'clock') : '';
	return (
		<div className={`chat_message chat-moderator-event chat-moderator-event--${moderatorEvent.event}`} data-id={message.id} data-testid='moderator-event'>
			{moderatorEvent.event !== 'asked' && <i className='fa fa-shield chat-moderator-event__icon' aria-hidden='true' />}
			<span className='chat-moderator-event__text'>{text}</span>
			{time && <span className='chat-moderator-event__time'>{time}</span>}
		</div>
	);
}
